import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT } from '../data/offer';
import { everythingIncluded } from '../data/everythingIncluded';
import { trackCheckout } from '../utils/tracking';
export function EverythingIncluded() {
  const featured = everythingIncluded.filter(item => item.featured);
  const supporting = everythingIncluded.filter(item => !item.featured);
  return <section className="py-24 px-4 bg-stone-50" data-id="element-65" data-mp="38n415zsrtsyv">
      <div className="max-w-5xl mx-auto" data-id="element-66" data-mp="3djaxd0vd7q3m">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-blue-950 text-center mb-12" data-id="element-67" data-mp="3dm6tcjnnk4pf">
          Everything Included in <span className="text-orange-600" data-id="element-68" data-mp="3mksm17mu903x">Driving Instructor Ready</span>
        </h2>

        <ul className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4" data-id="element-69" data-mp="3mifty1nd99d5">
          {featured.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-blue-950 border-b-4 border-orange-500 rounded-2xl p-5 flex flex-col items-start gap-3" data-id="element-70" data-mp="11u9z9qbfwiri">
              <Icon size={28} className="text-orange-500" aria-hidden="true" data-id="element-71" data-mp="1i7gfp38zyoav" />
              <span className="text-white font-extrabold text-sm md:text-base uppercase leading-snug" data-id="element-72" data-mp="1dbiy6tlzzbwi">
                {label}
              </span>
            </li>)}
        </ul>

        <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-20" data-id="element-73" data-mp="149i2w2abqzxh">
          {supporting.map(({
          label,
          icon: Icon
        }) => <li key={label} className="bg-white border border-stone-200 rounded-xl p-4 flex items-center gap-3" data-id="element-74" data-mp="uk8bypr7vnay">
              <span className="w-9 h-9 rounded-lg bg-blue-950/5 text-blue-700 flex items-center justify-center shrink-0" data-id="element-75" data-mp="plomwghbtved">
                <Icon size={18} aria-hidden="true" data-id="element-76" data-mp="kjzb2yma5dp8" />
              </span>
              <span className="text-blue-950 font-bold text-xs uppercase leading-tight" data-id="element-77" data-mp="gj5oq9ohk6yg">
                {label}
              </span>
            </li>)}
        </ul>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border-2 border-orange-500 rounded-3xl p-8 md:p-12 shadow-xl shadow-blue-950/10 text-center" data-id="element-78" data-mp="1xiat68vlyo1">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-2xl h-auto mx-auto mb-8" loading="lazy" data-id="element-79" data-mp="3t4b9a2cabjov" />
          <p className="text-2xl md:text-3xl font-serif font-extrabold text-blue-950 mb-3" data-id="element-80" data-mp="pm1awyhrv551">
            DRIVING INSTRUCTOR <span className="text-orange-600" data-id="element-81" data-mp="ay6ep84k2in7">READY</span>
          </p>
          <p className="text-base text-slate-700 max-w-2xl mx-auto mb-8" data-id="element-82" data-mp="fwhpbl2ocx6h">
            150 ready-to-teach driving lessons designed to help instructors plan less, explain skills
            more clearly and guide students from beginner foundations to more independent driving.
          </p>
          <p className="text-4xl md:text-5xl font-serif font-extrabold text-blue-950 mb-6" data-id="element-83" data-mp="2t3fyfmjv60s2">
            $27 USD
          </p>
          <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-84" data-mp="2o4d00kye2st2">
            GET THE COMPLETE DRIVING TEACHING SYSTEM NOW
          </Button>
          <p className="text-xs text-slate-500 mb-10" data-id="element-85" data-mp="2a5df9odzyy26">
            Immediate Access · Complete 6-in-1 System · One-Time Payment
          </p>
          <div className="pt-8 border-t border-stone-200" data-id="element-86" data-mp="257bvt2cnswq6">
            <p className="text-2xl md:text-3xl font-serif font-bold text-blue-950 mb-2" data-id="element-87" data-mp="2j61u2lb7t2g4">
              Stop Building Every Lesson From Scratch.
            </p>
            <p className="text-lg font-semibold text-orange-600" data-id="element-88" data-mp="2e5f95bdhqn6w">
              Open the system. Choose the lesson. Show the visual. Teach.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}